import React from "react";
import { useInterval } from "./useInterval";
import { useCycle } from "./useCycle";

export function Item({ v, i, symbol }) {
  const [show, cycle] = useCycle(["text", "price"]);
  useInterval(cycle, 5000, (i + 1) * 200);
  let diff = Number(v.latest) - Number(v.QUOTE_CLOSE);
  let price = Number(v.latest);
  let currency = symbol !== '' ? symbol.split('.')[1] : 'USD';
  return (
    <div
      className={
        "data-item " + (Number(v.latest) < Number(v.QUOTE_CLOSE) ? "red" : "")
      }
      key={i}
    >
      <p className="data-item__title">{v.name}</p>

      <div className={"data-item__bottom-line"} data-show={show}>
        <p className="data-item__text">
          {diff.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            signDisplay: "always"
          })}{" "}
          {(diff / price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: "percent",
            signDisplay: "always"
          })}
        </p>
        <p className="data-item__price">
          {price.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: "currency",
            currency: currency
          })}
        </p>
      </div>
    </div>
  );
}
